import { Component, OnInit } from '@angular/core';
import { UserService } from '../services/user/user.service';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { DataSharingService } from '../auth/data-sharing.service';
import { AdmindashboardService } from 'src/app/services/dashboard/admin/admindashboard.service';


@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {

  //userClaims: any;
  currentUserData: any;
  currentUserRole: any;
  isUserLoggedIn: boolean;
  isUserAdmin: boolean;
  isUserVendor: boolean;
  isUserFinance: boolean;
  isUserPurchase: boolean;
  isUserSiteinc: boolean;
  isUserTransport: boolean;


  constructor(private router: Router, private userService: UserService, private adminDashboardService:AdmindashboardService,
    private dataSharingService: DataSharingService) {


    this.dataSharingService.isUserLoggedIn.subscribe(
      value => {
        this.isUserLoggedIn = value;
      });
    this.userService.isUserAdmin.subscribe(
      value => {
        this.isUserAdmin = value;
      });
    this.userService.isUserVendor.subscribe(
      value => {
        this.isUserVendor = value;
      });
    this.userService.isUserFinance.subscribe(
      value => {
        this.isUserFinance = value;
      });
    this.userService.isUserPurchase.subscribe(
      value => {
        this.isUserPurchase = value;
      }
    );
    this.userService.isUserSiteinc.subscribe(
      value => {
        this.isUserSiteinc = value;
      }
    );
    this.userService.isUserTransport.subscribe(
      value => {
        this.isUserTransport = value;
      }
    );
  }

  ngOnInit() {

    // this.userService.getUserClaims().subscribe((data: any) => {
    //   this.userClaims = data;
    // });

    //code for getting current user data
    debugger;
    this.userService.currentUser.subscribe(
      (userdata) => {
        this.currentUserData = userdata;
      }
    );

    this.roleProvided();
  }


  roleProvided()
  {
    debugger;
    this.adminDashboardService.userRoleProvided().subscribe(
      (data) => {
        this.currentUserRole = data;
        debugger;
        if(this.currentUserRole != undefined && this.currentUserData != undefined && this.currentUserData.userTypeNew == "General" ){
          for(var i=0; i<this.currentUserRole.length; i++)
          {
            if(this.currentUserRole[i].roleId == this.currentUserData.roleType)
            {
              if(this.currentUserRole[i].userObjectId == 1)
              {
                if(!this.currentUserRole[i].read)
                {
                  document.getElementById("test").style.display = 'none';
                }
                // else
                // {
                //   document.getElementById("test").style.display = 'block';
                // }
              }
              if(this.currentUserRole[i].userObjectId == 2)
              {
                if(!this.currentUserRole[i].read)
                {
                  document.getElementById("test1").style.display = 'none';
                }
                // else
                // {
                //   document.getElementById("test1").style.display = 'block';
                // }
              }
              if(this.currentUserRole[i].userObjectId == 3)
              {
                if(!this.currentUserRole[i].read)
                {
                  document.getElementById("test2").style.display = 'none';
                }
                // else
                // {
                //   document.getElementById("test2").style.display = 'block';
                // }
              }
              if(this.currentUserRole[i].userObjectId == 5)
              {
                if(!this.currentUserRole[i].read)
                {
                  document.getElementById("test4").style.display = 'none';
                }
                // else
                // {
                //   document.getElementById("test4").style.display = 'block';
                // }
              }
              if(this.currentUserRole[i].userObjectId == 4)
              {
                if(!this.currentUserRole[i].read)
                {
                  document.getElementById("vrId").style.display = 'none';
                }
              }

              if(this.currentUserRole[i].userObjectId == 6)
              {
                if(!this.currentUserRole[i].read)
                {
                  document.getElementById("prescreen").style.display = 'none';
                }
              }

            }
          }
        }
        console.log("hello", this.currentUserRole);
      }
    );


  }

  Logout() {
    //localStorage.removeItem("userToken");
    this.userService.purgeAuth();
    this.router.navigate(['/home']);
  }

}
